import { render, staticRenderFns } from "./SystemCode.vue?vue&type=template&id=32d3fc0c&scoped=true"
import script from "./SystemCode.vue?vue&type=script&lang=js"
export * from "./SystemCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d3fc0c",
  null
  
)

export default component.exports